module.exports = {"data":{"site":{"siteMetadata":{"languages":{"defaultLangKey":"en","langs":["en","es"]}}}},"pathContext":{"slug":"/","langKey":"en"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 1237
// module chunks = 142629428675168